module.exports = "<p>\n  main works!\n</p>\n"